<template>
  <div id="app-index">
    <join-head></join-head>
    <nav-bar></nav-bar>
    <join-nav></join-nav>
    <join-foot></join-foot>
  </div>
</template>
<script>
import animate from 'animate.css'
import joinHead from "../Public/head";
import navBar from "../Public/nav";
import joinNav from "./join_nav";
import joinFoot from "../Public/foot";    

export default {
  components:{
    joinHead,
    navBar,
    joinFoot,
    joinNav
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Join/join_index.vue